import React, { useState } from "react";
import { Link } from "react-router-dom";
import { message } from "antd";
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import "./Styles/JobReset-Password.css";
import { useAuth } from "../hooks/useAuth";

const JobResetPassword = () => {
  const [form, setForm] = useState({ email: "" });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { resetEmail, loading } = useAuth();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!form.email) {
      message.error("Please enter your email address");
      return;
    }
    try {
      await resetEmail(form.email);
      setShowConfirmation(true);
    } catch (error) {}
  };

  return (
    <div className="job-reset-container">
      {showConfirmation ? (
        <JobResetConfirmation />
      ) : (
        <div className="job-reset-box">
          <img
            src="https://res.cloudinary.com/diomlp95m/image/upload/v1753190383/Frame_1000003027_cl3j77.png"
            alt="YouthPlus"
            className="job-logo"
          />
          <p className="job-reset-headtext">Forgot Password?</p>
          <p className="job-reset-subtext">
            To reset your password, please enter your email address below. You
            will receive a link to create a new password via email.
          </p>

          <form onSubmit={handleReset}>
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />

            <button type="submit" className="job-reset-btn">
              {loading ? (
                <>
                  <LoadingOutlined style={{ marginRight: 8 }} />
                  Sending Email
                </>
              ) : (
                "Reset Password"
              )}
            </button>
          </form>

          <p className="job-reset-link">
            <Link to="/jobs/job-auth/" className="job-reset-link">
              <LeftOutlined style={{ marginRight: "6px" }} />
              Back To Login
            </Link>
          </p>
        </div>
      )}
    </div>
  );
};

const JobResetConfirmation = () => {
  return (
    <div className="job-reset-box">
      <p className="job-reset-headtext">Check Your Email</p>
      <p className="job-reset-subtext">
        We've sent you an email with instructions to reset your password. Please
        check your inbox.
      </p>
      <p className="job-reset-subtexts">
        If you don't see the email within a few minutes, be sure to check your
        spam or junk folder.
      </p>
      <p className="job-reset-link">
        <Link to="/jobs/job-auth" className="job-reset-link">
          <LeftOutlined style={{ marginRight: "6px" }} />
          Back To Login
        </Link>
      </p>
    </div>
  );
};

export default JobResetPassword;
